import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { AuthenticationService } from '../core/services/auth.service'

@Component({
  selector: 'app-logo-box',
  standalone: true,
  imports: [CommonModule, RouterModule],
   styles: [`
    a:hover {
      cursor: pointer;
    }
  `],
  template: `
    <div [class]="className">
      <a (click)="gotoHome()" class="logo-dark">
        <img
          [src]="className === 'logo-box' ? 'assets/images/logo-game-sm.svg' : 'assets/images/logo-game.svg'"
          [ngClass]="className == 'logo-box' ? 'logo-lg' : 'me-1'"
          [height]="height"
          style="padding: 6px;"
          alt="GameHub"
        />
      </a>
      <a (click)="gotoHome()" class="logo-light">
        <img
          [src]="className === 'logo-box' ? 'assets/images/logo-game-sm.svg' : 'assets/images/logo-game.svg'"
          [ngClass]="className == 'logo-box' ? 'logo-lg' : 'me-1'"
          [height]="height"
          style="padding: 6px;"
          alt="GameHub"
        />
      </a>
    </div>
  `,
})
export class LogoBoxComponent {
  @Input() className: string = ''
  @Input() height: string = ''
  @Input() logoHeight: string = ''

  constructor(private router: Router, private authService: AuthenticationService,) { }

  gotoHome() {
    const currentUser = this.authService.session;
    if(currentUser)
      this.router.navigate(['/dashboard']);
    else return;
  }

}